import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Users, BookOpen, FileText } from 'lucide-react';
import { useGetStudentInstructorQuery } from '../../../store/studentApi';

type OverviewCardsProps = {
  resourcesCount: number;
};

const OverviewCards: React.FC<OverviewCardsProps> = ({ resourcesCount }) => {
  const { data: students } = useGetStudentInstructorQuery();

  return (
    <div className="grid gap-4 md:grid-cols-3">
      <Card className="transition-all duration-300 hover:shadow-lg bg-blue-300/30 dark:bg-blue-600/30">
        <CardHeader className="flex flex-row items-center justify-between pb-2">
          <CardTitle className="text-sm font-medium">
            <h1>Total Students</h1>
          </CardTitle>
          <Users className="h-4 w-4 text-slate-500" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{students?.length || 0}</div>
        </CardContent>
      </Card>

      <Card className="transition-all duration-300 hover:shadow-lg bg-teal-300/30 dark:bg-[#26BDB0]/30">
        <CardHeader className="flex flex-row items-center justify-between pb-2">
          <CardTitle className="text-sm font-medium">
            <h1>Course Resources</h1>
          </CardTitle>
          <FileText className="h-4 w-4 text-slate-500" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">{resourcesCount}</div>
        </CardContent>
      </Card>

      <Card className="transition-all duration-300 hover:shadow-lg bg-purple-300/30 dark:bg-purple-600/30">
        <CardHeader className="flex flex-row items-center justify-between pb-2">
          <CardTitle className="text-sm font-medium">
            <h1>Active Courses</h1>
          </CardTitle>
          <BookOpen className="h-4 w-4 text-slate-500" />
        </CardHeader>
        <CardContent>
          <div className="text-2xl font-bold">3</div>
        </CardContent>
      </Card>
    </div>
  );
};

export default OverviewCards;


